/**
 * Created by Mikhail Menshenin on 2/29/24
 */

const MedalFieldView = cleverapps.GridLayout.extend({
    ctor: function (game) {
        this.game = game;

        const styles = cleverapps.styles.MedalFieldView;

        this.createCells(styles);

        this._super(this.cells.map((cell) => cell.bg), {
            columns: MedalFieldView.FIELD_COLUMN_COUNT,
            margin: styles.margin,
            padding: styles.padding
        });

        this.createMedals();

        game.on("spawn", this.spawnAnimation.bind(this), this);
        game.on("select", this.selectAnimation.bind(this), this);
        game.on("unselect", this.removeSelect.bind(this), this);
        game.on("drop", this.dropAnimation.bind(this), this);
        game.on("merge", this.mergeAnimation.bind(this), this);
    },

    createCells: function (styles) {
        this.cells = this.game.createCells().map((cell) => {
            cell.bg = cleverapps.UI.createScale9Sprite(bundles.medalcollection.frames.cell_bg_png);
            cell.bg.setContentSize(styles.cell);
            return cell;
        });
    },

    createMedals: function () {
        this.cells.forEach((cell) => {
            const medal = this.game.getMedal(cell.x, cell.y);

            if (medal && medal.level) {
                this.createMedal(medal.level, cell);
            }
        });
    },

    createMedal: function (level, cellPos) {
        const cell = this.cells.find((cell) => cell.x === cellPos.x && cell.y === cellPos.y);

        if (!cell) {
            return;
        }

        const medal = cell.medal = new MedalItemView(this, level);
        medal.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });
        cell.bg.addChild(medal);

        return medal;
    },

    getMedalCell: function (medal) {
        return this.cells.find((cell) => cell.medal === medal);
    },

    getNearestCell: function (medal) {
        let minDist = cc.pDistance(this.cells[0].bg.getPosition(), this.cells[1].bg.getPosition());
        let nearestCell = undefined;
        const medalPos = medal.parent.convertToWorldSpace(medal.getPosition());

        for (let i = 0; i < this.cells.length; i++) {
            const cell = this.cells[i];
            const cellPos = cell.bg.parent.convertToWorldSpace(cell.bg.getPosition());
            const dist = cc.pDistance(cellPos, medalPos);
            if (dist < minDist) {
                minDist = dist;
                nearestCell = cell;
            }
        }

        return nearestCell;
    },

    spawnAnimation: function (cellPos, cb) {
        const cell = this.cells.find((cell) => cell.x === cellPos.x && cell.y === cellPos.y);
        const data = this.game.getMedal(cell.x, cell.y);
        const medal = this.createMedal(data.level, cell);

        const spawnAnimation = new cleverapps.Spine(bundles.medalcollection.jsons.spawn_animation_json);
        spawnAnimation.setAnimation(0, "animation", false);
        spawnAnimation.setCompleteListenerRemove();
        spawnAnimation.setPosition(cell.bg.getPosition());
        this.addChild(spawnAnimation);

        medal.runAction(
            new cc.Sequence(
                cleverapps.effects.fireAction("medalcollection.open"),
                new cc.FadeIn(0.3),
                new cc.DelayTime(0.6),
                new cc.CallFunc(cb || (() => { }))
            )
        );
    },

    selectAnimation: function (cellPos) {
        const styles = cleverapps.styles.MedalFieldView;
        const cell = cellPos && this.cells.find((cell) => cell.x === cellPos.x && cell.y === cellPos.y);

        if (cell) {
            const selectAnimation = cell.select = new cleverapps.Spine(bundles.medalcollection.jsons.select_animation_json);
            selectAnimation.setAnimation(0, "animation", true);
            selectAnimation.setAlignment(styles.select);
            cell.bg.addChild(selectAnimation);
        }
    },

    removeSelect: function () {
        this.cells.forEach((cell) => {
            if (cell.select) {
                cell.select.removeFromParent();
                cell.select = undefined;
            }
        });
    },

    dropAnimation: function (cellFromPos, cellToPos) {
        const cellFrom = this.cells.find((cell) => cell.x === cellFromPos.x && cell.y === cellFromPos.y);
        const cellTo = cellToPos && this.cells.find((cell) => cell.x === cellToPos.x && cell.y === cellToPos.y);
        const targetNode = cellTo ? cellTo.bg : cellFrom.bg;
        const medal = cellFrom.medal;

        if (cellTo) {
            cellFrom.medal = undefined;
            cellTo.medal = medal;
        }

        medal.runAction(
            new cc.Sequence(
                cleverapps.effects.fireAction("medalcollection.put"),
                new cc.MoveTo(0.2, cc.Base.GetTargetPosition(medal, targetNode)),
                new cc.CallFunc(() => {
                    medal.replaceParentSamePlace(targetNode);
                    medal.setAlignment({
                        x: { align: "center" },
                        y: { align: "center" }
                    });
                    medal.showLevelText();
                })
            )
        );
    },

    mergeAnimation: function (cellFromPos, cellToPos, level, cb) {
        const cellFrom = this.cells.find((cell) => cell.x === cellFromPos.x && cell.y === cellFromPos.y);
        const cellTo = this.cells.find((cell) => cell.x === cellToPos.x && cell.y === cellToPos.y);
        const medalFrom = cellFrom.medal;
        const medalTo = cellTo.medal;
        const targetNode = cellTo.bg;

        const mergeAnimation = new cleverapps.Spine(bundles.medalcollection.jsons.merge_animation_json);
        mergeAnimation.setPosition(cellTo.bg.getPosition());
        mergeAnimation.setCompleteListenerRemove();
        this.addChild(mergeAnimation);
        mergeAnimation.setVisible(false);

        medalFrom.runAction(
            cc.sequence(
                cc.callFunc(() => {
                    medalFrom.setPosition(cc.Base.GetTargetPosition(medalFrom, targetNode));
                }),
                cc.moveBy(0.1, -100, 0).easing(cc.easeOut(3)),
                cc.callFunc(() => {
                    mergeAnimation.setVisible(true);
                    mergeAnimation.setLocalZOrder(100);
                    mergeAnimation.setAnimation(0, "animation", false);
                }),
                cc.moveBy(0.1, 100, 0).easing(cc.easeIn(3)),
                cc.hide(),
                cc.callFunc(() => {
                    this.createMedal(level, cellTo);

                    const newMedal = cellTo.medal;
                    newMedal.runAction(cleverapps.UI.animateScale({
                        scale: 1,
                        duration: 0.3,
                        overScaling: 1.2
                    }));
                }),
                cc.delayTime(1),
                cc.callFunc(() => {
                    if (cb) {
                        cb();
                    }
                }),
                cc.removeSelf()
            )
        );

        medalTo.placeOnTop();
        medalTo.setLocalZOrder(99);
        medalTo.hideLevelText();
        medalTo.runAction(
            new cc.Sequence(
                cleverapps.effects.fireAction("medalcollection.merge"),
                new cc.MoveBy(0.1, 100, 0).easing(cc.easeOut(3)),
                new cc.MoveBy(0.1, -100, 0).easing(cc.easeIn(3)),
                new cc.RemoveSelf()
            )
        );
    }
});

MedalFieldView.FIELD_COLUMN_COUNT = 4;

cleverapps.styles.MedalFieldView = {
    margin: {
        x: 16,
        y: 16
    },

    padding: {
        top: 40,
        bottom: 48
    },

    select: {
        x: { align: "center" },
        y: { align: "center" }
    },

    cell: {
        width: 158,
        height: 158
    }
};
